import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Grocerycardsdata from "./Grocerycardsdata";
import Logisticssubscriptionmodalpage from "./Logisticssubscriptionmodalpage";

// Import your grocery images
// Import your franchise images D:\vendor\Actus(new)\src\images\aaaservices\ASHOK.avif
import img1 from "../../../images/aaaservices/ASHOK.avif";
import img2 from "../../../images/aaaservices/MAHENDRA1.jpg";
import img3 from "../../../images/aaaservices/large.jpg";
import img4 from "../../../images/aaaservices/ASHOK.avif";

const Logisticsbanner = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <>
      <style>{`
        /* Grocery Banner Styles */
        .grocery-banner-top {
          text-align: center;
          margin-bottom: 30px;
          margin-top: -50px;
          max-width: 1017px;
          margin-left: auto;
          margin-right: auto;
        }

        .grocery-banner-top h1 {
          font-size: 3rem;
          font-weight: bold;
          line-height: 1.2;
          margin-bottom: 15px;
          color: #333;
        }

        .grocery-banner-top p {
          font-size: 1.1rem;
          line-height: 1.6;
          margin-bottom: 20px;
          color: #666;
        }

        .grocery-banner-slider {
          width: 100%;
          max-width: 1000px;
          margin: 0 auto;
        }

        .grocery-slide {
          position: relative;
          height: 420px;
        }

        .grocery-slide img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 14px;
        }

        .grocery-slide-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.45);
          border-radius: 14px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: #fff;
          padding: 20px;
        }

        .grocery-slide-overlay h2 {
          font-size: 2rem;
          margin-bottom: 12px;
        }

        .grocery-slide-overlay p {
          font-size: 1rem;
          max-width: 650px;
        }

        @media (max-width: 1024px) {
          .grocery-banner-top h1 {
            font-size: 2.4rem;
          }
          .grocery-slide {
            height: 320px;
          }
        }

        @media (max-width: 600px) {
          .grocery-banner-top h1 {
            font-size: 1.9rem;
          }
          .grocery-banner-top p {
            font-size: 0.95rem;
          }
          .grocery-slide {
            height: 220px;
          }
          .grocery-slide-overlay h2 {
            font-size: 1.3rem;
          }
          .grocery-slide-overlay p {
            font-size: 0.85rem;
          }
        }
      `}</style>

      {/* Slider Section */}
      <div className="grocery-banner-slider" style={{ marginTop: "-50px" }}>
        <Slider {...settings}>
          <div className="grocery-slide">
            <img src={img1} alt="Fresh Fruits" />
            <div className="grocery-slide-overlay">
              <h2>Logistics & Services</h2>
              <p>Reliable logistics and services to ensure timely delivery and smooth operations.</p>
            </div>
          </div>
          <div className="grocery-slide">
            <img src={img2} alt="Organic Vegetables" />
            <div className="grocery-slide-overlay">
              <h2>Logistics & Services</h2>
              <p>Reliable logistics and services to ensure timely delivery and smooth operations.</p>
            </div>
          </div>
          <div className="grocery-slide">
            <img src={img3} alt="Daily Essentials" />
            <div className="grocery-slide-overlay">
              <h2>Logistics & Services</h2>
              <p>Reliable logistics and services to ensure timely delivery and smooth operations.</p>
            </div>
          </div>
          <div className="grocery-slide">
            <img src={img4} alt="Snacks & Beverages" />
            <div className="grocery-slide-overlay">
              <h2>Logistics & Services</h2>
              <p>Reliable logistics and services to ensure timely delivery and smooth operations.</p>
            </div>
          </div>
        </Slider>
      </div>

      {/* Other Components Below */}
      <div style={{ marginTop: "25px" }}>
        <Grocerycardsdata />
      </div>
      <div style={{ marginTop: "20px" }}>
        <Logisticssubscriptionmodalpage />
      </div>
    </>
  );
};

export default Logisticsbanner;
